import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Paginated } from '@app/shared/models';
import { Student } from '../models';

export const studentsActions = createActionGroup({
    source: 'Admin Students',
    events: {
        'Get Students': props<{ page: number; limit: number }>(),
        'Get Students Success': props<{ payload: Paginated<Student[]> }>(),
        'Get Students Error': emptyProps(),

        'Reload Students': emptyProps(),

        Clear: emptyProps(),
    },
});
